module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "part-title"
  }, [_c('span', {
    staticClass: "part-num"
  }, [_vm._v("PART I")]), _c('br'), _vm._v("Clearing Your Path to Retirement")]), _vm._v(" "), _c('p', {
    staticClass: "part-intro"
  }, [_vm._v("Before you decide what specific path you’d like to take in your retirement, we need to go over some basic concepts. If you’ve read other retirement books, including my "), _c('i', [_vm._v("The 5 Years Before You Retire")]), _vm._v(" (shameless plug!), you may be familiar with some of this material. However, it never hurts to go over it again.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9b78c08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Part1.vue
// module id = 75
// module chunks = 0